import type { JSX, ReactNode } from 'react';
import { Select } from './Select.js';

/** Поля форм библиотек. Подписи приходят строками — словарь читает вызывающий. */

export function TextField({
  label,
  value,
  onChange,
  placeholder,
  hint,
}: {
  label: string;
  value: string;
  onChange(value: string): void;
  placeholder?: string;
  hint?: string;
}): JSX.Element {
  return (
    <label className="grid gap-1.5 text-sm font-medium">
      {label}
      <input
        className="kitup-input"
        value={value}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
      {hint ? (
        <span className="text-xs font-normal text-[var(--kitup-color-muted)]">{hint}</span>
      ) : null}
    </label>
  );
}

export function NumberField({
  label,
  value,
  min,
  max,
  onChange,
}: {
  label: string;
  value: number | null;
  min: number;
  max: number;
  onChange(value: number | null): void;
}): JSX.Element {
  return (
    <label className="grid gap-1.5 text-sm font-medium">
      {label}
      <input
        className="kitup-input"
        type="number"
        min={min}
        max={max}
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value ? Number(event.target.value) : null)}
      />
    </label>
  );
}

export function TextArea({
  label,
  value,
  onChange,
  hint,
  rows,
}: {
  label: string;
  value: string;
  onChange(value: string): void;
  hint?: string;
  rows?: number;
}): JSX.Element {
  return (
    <label className="grid gap-1.5 text-sm font-medium">
      {label}
      <textarea
        className="kitup-input min-h-24 resize-y"
        value={value}
        rows={rows}
        onChange={(event) => onChange(event.target.value)}
      />
      {hint ? (
        <span className="text-xs font-normal text-[var(--kitup-color-muted)]">{hint}</span>
      ) : null}
    </label>
  );
}

export function SelectField<T extends string>({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: T;
  options: readonly { readonly value: T; readonly label: string }[];
  onChange(value: T): void;
}): JSX.Element {
  return (
    <label className="grid gap-1.5 text-sm font-medium">
      {label}
      <Select value={value} options={options} onChange={onChange} />
    </label>
  );
}

export function Section({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <section className="mt-7">
      <h3 className="font-semibold">{title}</h3>
      {description ? (
        <p className="mt-1 text-sm text-[var(--kitup-color-muted)]">{description}</p>
      ) : null}
      <div className="mt-3">{children}</div>
    </section>
  );
}
